import React, { useState, useEffect } from 'react';
import api from '../../../services/api'; // Importando a instância do axios
import './Cronograma.css';

import imgSegunda from '../../../assets/segunda.png';
import imgTerca from '../../../assets/terca.png';
import imgQuarta from '../../../assets/quarta.png';
import imgQuinta from '../../../assets/quinta.png';
import imgSexta from '../../../assets/sexta.png';
import imgSabado from '../../../assets/sabado.png';
import imgDomingo from '../../../assets/domingo.png';

const imagensDias = [imgSegunda, imgTerca, imgQuarta, imgQuinta, imgSexta, imgSabado, imgDomingo];

const Cronograma = () => {
  const [modalAberto, setModalAberto] = useState(false);
  const [semanaSelecionada, setSemanaSelecionada] = useState('');
  const [diaSelecionado, setDiaSelecionado] = useState(null);
  const [formData, setFormData] = useState({});
  const [cronogramas, setCronogramas] = useState([]);

  const abrirModal = (semana) => {
    setSemanaSelecionada(semana);
    setModalAberto(true);
    setDiaSelecionado(null);
  };

  const fecharModal = () => {
    setModalAberto(false);
    setSemanaSelecionada('');
    setDiaSelecionado(null);
  };

  const abrirFormularioDia = (dia) => {
    // Procurando se já existem dados salvos para o dia selecionado
    const dadosDoDia = cronogramas.find(cronograma => 
      cronograma.dias.some(d => d.numeroSemana === parseInt(semanaSelecionada.split(' ')[1]) && d.numeroDia === dia)
    );
  
    const dadosExistentes = dadosDoDia
      ? dadosDoDia.dias.find(d => d.numeroDia === dia)
      : null;
  
    setDiaSelecionado(dia);
  
    // Atualizando o estado com os dados do dia, caso existam, senão mantendo placeholders
    setFormData((prevData) => ({
      ...prevData,
      [dia]: dadosExistentes || {
        pilulas: '',
        cafeDaManha: '',
        almoco: '',
        lancheDaTarde: '',
        jantar: '',
        videos: []
      }
    }));
  };
  

  const handleInputChange = (e, field) => {
    setFormData((prevData) => ({
      ...prevData,
      [diaSelecionado]: {
        ...prevData[diaSelecionado],
        [field]: e.target.value
      }
    }));
  };

  const handleVideoUpload = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter(file => file.type === 'video/mp4');

    if (validFiles.length > 0) {
      setFormData((prevData) => ({
        ...prevData,
        [diaSelecionado]: {
          ...prevData[diaSelecionado],
          videos: [
            ...prevData[diaSelecionado].videos,
            ...validFiles.map(file => URL.createObjectURL(file))
          ]
        }
      }));
    } else {
      alert('Por favor, selecione arquivos no formato .mp4');
    }
  };

  const removerVideo = (index) => {
    setFormData((prevData) => {
      const novosVideos = [...prevData[diaSelecionado].videos];
      novosVideos.splice(index, 1);
      return {
        ...prevData,
        [diaSelecionado]: {
          ...prevData[diaSelecionado],
          videos: novosVideos
        }
      };
    });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
  
    const novoCronograma = {
      dias: [{
        numeroSemana: parseInt(semanaSelecionada.split(' ')[1]),
        numeroDia: diaSelecionado,
        pilulas: formData[diaSelecionado].pilulas,
        cafeDaManha: formData[diaSelecionado].cafeDaManha,
        almoco: formData[diaSelecionado].almoco,
        lancheDaTarde: formData[diaSelecionado].lancheDaTarde,
        jantar: formData[diaSelecionado].jantar,
        videos: formData[diaSelecionado].videos
      }]
    };
  
    try {
      // Verifica se já existe um cronograma com o mesmo número de semana e dia
      const { data: cronogramasExistentes } = await api.get('/');
      const cronogramaExistente = cronogramasExistentes.find(cronograma =>
        cronograma.dias.some(dia =>
          dia.numeroSemana === novoCronograma.dias[0].numeroSemana &&
          dia.numeroDia === novoCronograma.dias[0].numeroDia
        )
      );
  
      if (cronogramaExistente) {
        // Se existir, pode-se atualizar (PUT) ou deletar e recriar
        await api.put(`/${cronogramaExistente._id}`, novoCronograma);
        alert('Cronograma atualizado com sucesso!');
      } else {
        // Se não existir, criar um novo (POST)
        await api.post('/', novoCronograma);
        alert('Cronograma salvo com sucesso!');
      }
  
      fecharModal(); // Fecha o modal após salvar
      fetchCronogramas(); // Atualiza a lista de cronogramas
    } catch (error) {
      console.error('Erro ao salvar o cronograma:', error);
      alert('Erro ao salvar o cronograma. Tente novamente.');
    }
  };
  

  const fetchCronogramas = async () => {
    try {
      const response = await api.get('/'); // Usando a instância 'api'
      setCronogramas(response.data);
    } catch (error) {
      console.error('Erro ao buscar cronogramas:', error);
    }
  };

  useEffect(() => {
    fetchCronogramas();
  }, []);

  return (
    <div className="cronograma-container">
      <h1>Cronograma de Semanas</h1>
      <div className="flex-container">
        {[...Array(12)].map((_, index) => (
          <div key={index} className="card" onClick={() => abrirModal(`Semana ${index + 1}`)}>
            <h2>Semana {index + 1}</h2>
            <p>Conteúdo planejado para esta semana.</p>
          </div>
        ))}
      </div>

      {modalAberto && (
        <div className="modal-overlay" onClick={fecharModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>

            {!diaSelecionado ? (
              <>
                <h2>{semanaSelecionada}</h2>
                <div className="flex-container">
                  {[...Array(7)].map((_, diaIndex) => (
                    <div key={diaIndex} className="card" onClick={() => abrirFormularioDia(diaIndex + 1)}>
                      <h3>Dia {diaIndex + 1} - {semanaSelecionada}</h3>
                      <img src={imagensDias[diaIndex]} alt={`Capa do Dia ${diaIndex + 1}`} className="capa-dia" />

                    </div>
                  ))}
                </div>
                <button className="fechar-btn" onClick={fecharModal}>Fechar</button>
              </>
            ) : (
              <>
                <h2>Dia {diaSelecionado} - {semanaSelecionada}</h2>
                <form onSubmit={handleFormSubmit} className="formulario">

                  {/* Pílulas Diárias */}
                  <label>Pílulas Diárias</label>
                  <input
                    type="text"
                    value={formData[diaSelecionado]?.pilulas || ''}
                    onChange={(e) => handleInputChange(e, 'pilulas')}
                    maxLength="300"
                    placeholder="Digite até 300 caracteres..."
                  />

                  {/* Dieta do Dia */}
                  <label>Café da Manhã</label>
                  <textarea
                    value={formData[diaSelecionado]?.cafeDaManha || ''}
                    onChange={(e) => handleInputChange(e, 'cafeDaManha')}
                    placeholder="Digite o cardápio do café da manhã..."
                  />

                  <label>Almoço</label>
                  <textarea
                    value={formData[diaSelecionado]?.almoco || ''}
                    onChange={(e) => handleInputChange(e, 'almoco')}
                    placeholder="Digite o cardápio do almoço..."
                  />

                  <label>Lanche da Tarde</label>
                  <textarea
                    value={formData[diaSelecionado]?.lancheDaTarde || ''}
                    onChange={(e) => handleInputChange(e, 'lancheDaTarde')}
                    placeholder="Digite o cardápio do lanche da tarde..."
                  />

                  <label>Jantar</label>
                  <textarea
                    value={formData[diaSelecionado]?.jantar || ''}
                    onChange={(e) => handleInputChange(e, 'jantar')}
                    placeholder="Digite o cardápio do jantar..."
                  />

                  {/* Vídeos Funcionais */}
                  <label>Adicionar Vídeos (.mp4)</label>
                  <input type="file" accept="video/mp4" multiple onChange={handleVideoUpload} />

                  {/* Exibir vídeos enviados */}
                  {formData[diaSelecionado]?.videos?.length > 0 && (
                    <div className="video-list">
                      {formData[diaSelecionado].videos.map((video, index) => (
                        <div key={index} className="video-item">
                          <video width="100%" controls>
                            <source src={video} type="video/mp4" />
                            Seu navegador não suporta vídeos.
                          </video>
                          <button type="button" onClick={() => removerVideo(index)}>Remover</button>
                        </div>
                      ))}
                    </div>
                  )}

                  <div className="modal-actions">
                    <button type="submit">Salvar</button>
                    <button type="button" onClick={() => setDiaSelecionado(null)}>Voltar</button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Cronograma;